import { render, staticRenderFns } from "./prints.vue?vue&type=template&id=721570dc&scoped=true&"
import script from "./prints.vue?vue&type=script&lang=js&"
export * from "./prints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721570dc",
  null
  
)

export default component.exports